var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[(!_vm.errorPageMessage)?_c('div',{staticClass:"header-info"},[_c('span',[_vm._v(_vm._s(_vm.translate('game_NumbersBetting')))]),(!_vm.internetConnection)?_c('span',[_vm._v(" - "+_vm._s(_vm.translate('shop_bettingDisabled')))]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }